define(function(require) {
	const tpl = require('./t_lov_site_map.hbs');
	const IpsModel = require('civicsBase/ipsModel');
	const MapUtil = require('civicsUtils/map_utilities');
  const ViewManager = require('civicsUtils/view_manager');
	const MapView = require('civicsViews/agencymap_view/v_agencymap');
	const GisSyncUtil = require('civicsUtils/gis_sync_utilities');
	const SyncModel = require('civicsModels/sync_model');

	return Marionette.LayoutView.extend({
		template: tpl,
		className: 'map-region',
		ui:{
			mapDiv: '.map-view',
		},
		regions: {
			agencyMapRegion: '@ui.mapDiv'
		},
		mapEventsEnabled: true,
		initialize: function(options) {
			this.config = options.config;
			this.parent = options.parent;
		},
		onShow: function() {
			var self = this;
			if (!this.mapView) {
				this.mapView = new MapView({
					config: {
						mapConfig: 'rhythm-civics-address-picker',
						channel: this
					}
				});
			}

			this.agencyMapRegion.show(this.mapView);
			//console.log('MAP LOG: BINDING EVENT');
			this.on("civics:map-click-results", info => {

				ViewManager.resetErrorMessages(self);
				if (typeof $('.rhy.container-controlled-padded') === 'object')
				    $('.rhy.container-controlled-padded').remove(); //need to remove this, it affects the top padding for the map view modal.

				var rawFeatures = [];
				var syncData = [];

				if (info.raw.args.out && info.raw.args.out.events) {
					_.forEach(info.raw.args.out.events, x => {
						if (x.eventArgs.out.layers) {
							var features =x.eventArgs.out.layers['0'].features;
							if(features[0]) {
								//these all come from the same event so they will
								//all have the same syncMapping, syncMoniker, etc
								var mdl = GisSyncUtil.createSyncModel(features[0].attributes);

								if(mdl != null) {
									syncData.push(mdl);
								}
							}

							var eventName = x.eventName;
							if(eventName != null && eventName.startsWith('address')) {
									features.forEach(feature=>{ feature.attributes.syncEventType = 'address'; });
							} else if(eventName !=null && eventName.startsWith('parcel')){
									features.forEach(feature=>{ feature.attributes.syncEventType = 'parcel'; });
							}


							rawFeatures = rawFeatures.concat(features);
						}
					});
					// after adding the parcel/address, now add the points
					var feature = MapUtil.coordsToFeature(info.raw.args.in.findOption('box'));
					if (feature) {
						rawFeatures.push(feature);
					}
				} else {
					var feature = MapUtil.coordsToFeature(info.raw.args.in.findOption('box'));
					if (feature) {
						rawFeatures.push(feature);
					}
				}
				if (rawFeatures && rawFeatures.length > 0) {
					this.triggerMethod('mapClicked', rawFeatures, syncData);
				}
			});
		},
		onRender: function() {},
		processMapClick: function(feature) {
			//console.log('MAP LOG: processing click',feature);
			if (feature.attributes && feature.attributes.type && feature.attributes.type.toLowerCase() == 'address') {
				var split = feature.attributes.id.split('/');
				var end = split[split.length - 1];
				var split2 = end.split('?');
				feature.attributes.id = split2[0];
			} else { //we need to process parcels from the map because they are not IPS parcels, they are GIS parcels.
				feature.attributes.type = 'Parcel';
				feature.attributes.parcelId = feature.attributes.PRCLID;
				feature.attributes.id = feature.attributes.PRCLKEY;
			}
			var site = new IpsModel(feature.attributes);
			this.parent.mapSiteSelected(feature.attributes, site);
		},
		templateHelpers: function() {
			var self = this;
			return {}
		}
	});
});
